var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"activity-result__stack-list__item",class:{ active: _vm.active, selected: _vm.selected }})}
var staticRenderFns = []

export { render, staticRenderFns }